import { useNavigate } from "@tanstack/react-router";

import { useIsEmailHubStatusEnabled } from "@/react/hooks/useIsEmailHubStatus";

import { useCreateFromSource } from "../shared/Emails/useCreateFromSource";

export const useConvertPostToBroadcast = () => {
  const navigate = useNavigate();
  const { mutate: convertFromSource, ...rest } = useCreateFromSource();
  const isEmailHubEnabled = useIsEmailHubStatusEnabled();

  const handleShareViaBroadcast = ({
    postId,
    onSuccess,
  }: {
    postId: number;
    onSuccess?: () => void;
  }) => {
    if (!isEmailHubEnabled) {
      void navigate({ to: "/settings/emails/broadcast" });
      onSuccess?.();
      return;
    }

    convertFromSource(
      {
        source_content_id: postId,
        source_content_type: "Post",
      },
      {
        onSuccess: data => {
          onSuccess?.();
          void navigate({
            to: "/settings/emails/broadcast/$id/edit",
            params: { id: String(data.broadcast.id) },
          });
        },
      },
    );
  };

  return {
    onShareViaBroadcast: handleShareViaBroadcast,
    ...rest,
  };
};
